import { getField, updateField } from "vuex-map-fields";
import Repository from "@/repository";

const PARTLOCATION_API = "/partLocation";

// ----------------------- STATE ------------------------- //
const state = {
  partlocation_data: [],
  currentIndex: -1
};

// ----------------------- GETTERS ----------------------- //
const getters = {
  getPartLocation: state =>
    getField(state.partlocation_data[state.currentIndex]),

  getCurrentPartLocation: state => {
    return state.partlocation_data[state.currentIndex];
  }
};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
  updatePartLocation(state, payload) {
    updateField(state.partlocation_data[state.currentIndex], payload);
  },

  setCurrentIndexByID(state, theID) {
    state.currentIndex = state.partlocation_data.findIndex(
      partlocation => partlocation.id == theID
    );
  },

  loadAllPartLocations(state, payload) {
    state.partlocation_data = payload.data;
    state.currentIndex = 0;
  },

  addPartLocation(state, payload) {
    state.partlocation_data.push(payload.data);
    state.currentIndex = state.partlocation_data.length - 1;
  },

  savePartLocation(state, payload) {
    state.partlocation_data[state.currentIndex] = payload.data;
  },

  fetchPartLocation(state, payload) {
    if (state.currentIndex == -1) {
      state.partlocation_data.push(payload.data);
      state.currentIndex = 0;
    } else {
      state.partlocation_data[state.currentIndex] = payload.data;
    }
  },

  deletePartLocation(state, payload) {
    state.currentIndex = state.partlocation_data.findIndex(
      partlocation => partlocation.id == payload.data.id
    );
    state.partlocation_data.splice(state.currentIndex, 1);
  },
  reset(state) {
    state.partlocation_data = []
    state.currentIndex = -1
  }
};

// ----------------------- ACTIONS -------------------- //
const actions = {
  async loadAllPartLocations({ commit }) {
    try {
      commit(
        "loadAllPartLocations",
        await Repository.get(`${PARTLOCATION_API}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async addPartLocation({ commit }) {
    await Repository.get(`${PARTLOCATION_API}/new`)
      .then(response => {
        commit("addPartLocation", response);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async savePartLocation({ state, commit }) {
    try {
      commit(
        "savePartLocation",
        await Repository.post(
          `${PARTLOCATION_API}`,
          state.partlocation_data[state.currentIndex]
        )
      );
    } catch (error) {
      console.log(error);
    }
  },

  async fetchPartLocation({ commit }, payloadID) {
    try {
      commit(
        "fetchPartLocation",
        await Repository.get(`${PARTLOCATION_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async deletePartLocation({ commit }, payloadID) {
    try {
      commit(
        "deletePartLocation",
        await Repository.delete(`${PARTLOCATION_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async searchPartLocations({ commit }, searchTerm) {
    try {
      commit(
        "loadAllPartLocations",
        await Repository.get(`${PARTLOCATION_API}/search?q=${searchTerm}`)
      );
    } catch (error) {
      console.log(error);
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
